import {
    Freelancer,
    FreelancerCardOperator,
    FreelancerCustomer,
    FreelancerFeedbackItem
} from '../../typings/freelancers';
import { GdFreelancerStatus } from '../../typings/graphql-grid';

export const WITHDRAW_REQUEST_BY_CLIENT_START = 'WITHDRAW_REQUEST_BY_CLIENT_START';
export type WITHDRAW_REQUEST_BY_CLIENT_START = typeof WITHDRAW_REQUEST_BY_CLIENT_START;

export const WITHDRAW_REQUEST_BY_CLIENT_SUCCESS = 'WITHDRAW_REQUEST_BY_CLIENT_SUCCESS';
export type WITHDRAW_REQUEST_BY_CLIENT_SUCCESS = typeof WITHDRAW_REQUEST_BY_CLIENT_SUCCESS;

export const WITHDRAW_REQUEST_BY_CLIENT_ERROR = 'WITHDRAW_REQUEST_BY_CLIENT_ERROR';
export type WITHDRAW_REQUEST_BY_CLIENT_ERROR = typeof WITHDRAW_REQUEST_BY_CLIENT_ERROR;

export const FETCH_FREELANCER_CARD_DATA = 'FETCH_FREELANCER_CARD_DATA';
export type FETCH_FREELANCER_CARD_DATA = typeof FETCH_FREELANCER_CARD_DATA;

export const FETCH_FREELANCER_CARD_REGISTERED_DATA = 'FETCH_FREELANCER_CARD_REGISTERED_DATA';
export type FETCH_FREELANCER_CARD_REGISTERED_DATA = typeof FETCH_FREELANCER_CARD_REGISTERED_DATA;

export const UPDATE_FREELANCER_CARD_DATA = 'UPDATE_FREELANCER_CARD_DATA';
export type UPDATE_FREELANCER_CARD_DATA = typeof UPDATE_FREELANCER_CARD_DATA;

export const SHOW_FREELANCER_CONTACTS = 'SHOW_FREELANCER_CONTACTS';
export type SHOW_FREELANCER_CONTACTS = typeof SHOW_FREELANCER_CONTACTS;

export const UPDATE_FREELANCER_STATUS = 'UPDATE_FREELANCER_STATUS';
export type UPDATE_FREELANCER_STATUS = typeof UPDATE_FREELANCER_STATUS;

export const HANDLE_UPDATE_FREELANCER_STATUS_SUCCESS = 'HANDLE_UPDATE_FREELANCER_STATUS_SUCCESS';
export type HANDLE_UPDATE_FREELANCER_STATUS_SUCCESS = typeof HANDLE_UPDATE_FREELANCER_STATUS_SUCCESS;

export const HANDLE_UPDATE_FREELANCER_STATUS_ERROR = 'HANDLE_UPDATE_FREELANCER_STATUS_ERROR';
export type HANDLE_UPDATE_FREELANCER_STATUS_ERROR = typeof HANDLE_UPDATE_FREELANCER_STATUS_ERROR;

export const OPEN_ACCEPT_FREELANCER_COOP_REQUEST_BY_CLIENT = 'OPEN_ACCEPT_FREELANCER_COOP_REQUEST_BY_CLIENT';
export type OPEN_ACCEPT_FREELANCER_COOP_REQUEST_BY_CLIENT = typeof OPEN_ACCEPT_FREELANCER_COOP_REQUEST_BY_CLIENT;

export const CLOSE_ACCEPT_FREELANCER_COOP_REQUEST_BY_CLIENT = 'CLOSE_ACCEPT_FREELANCER_COOP_REQUEST_BY_CLIENT';
export type CLOSE_ACCEPT_FREELANCER_COOP_REQUEST_BY_CLIENT = typeof CLOSE_ACCEPT_FREELANCER_COOP_REQUEST_BY_CLIENT;

export const ACKNOWLEDGE_USER_STAYED_ON_CARD = 'ACKNOWLEDGE_USER_STAYED_ON_CARD';
export type ACKNOWLEDGE_USER_STAYED_ON_CARD = typeof ACKNOWLEDGE_USER_STAYED_ON_CARD;

export const RELEASE_FREELANCER_CARD = 'RELEASE_FREELANCER_CARD';
export type RELEASE_FREELANCER_CARD = typeof RELEASE_FREELANCER_CARD;

export const UPDATE_FREELANCER_CARD_PRIVATE_DATA = 'UPDATE_FREELANCER_CARD_PRIVATE_DATA';
export type UPDATE_FREELANCER_CARD_PRIVATE_DATA = typeof UPDATE_FREELANCER_CARD_PRIVATE_DATA;

export const UPDATE_FREELANCER_CUSTOMER_DATA = 'UPDATE_FREELANCER_CUSTOMER_DATA';
export type UPDATE_FREELANCER_CUSTOMER_DATA = typeof UPDATE_FREELANCER_CUSTOMER_DATA;

export const SET_FREELANCER_CARD_ERROR = 'SET_FREELANCER_CARD_ERROR';
export type SET_FREELANCER_CARD_ERROR = typeof SET_FREELANCER_CARD_ERROR;

export const SET_FREELANCER_CARD_NOT_FOUND = 'SET_FREELANCER_CARD_NOT_FOUND';
export type SET_FREELANCER_CARD_NOT_FOUND = typeof SET_FREELANCER_CARD_NOT_FOUND;

export const FREELANCER_CARD_UPDATE_CUSTOMER_PHONE = 'FREELANCER_CARD_UPDATE_CUSTOMER_PHONE';
export type FREELANCER_CARD_UPDATE_CUSTOMER_PHONE = typeof FREELANCER_CARD_UPDATE_CUSTOMER_PHONE;

export const FRELANCER_CARD_INCOGNITO_GO_TO_PASSPORT = 'FRELANCER_CARD_INCOGNITO_GO_TO_PASSPORT';
export type FRELANCER_CARD_INCOGNITO_GO_TO_PASSPORT = typeof FRELANCER_CARD_INCOGNITO_GO_TO_PASSPORT;

export const FRELANCER_CARD_INCOGNITO_GO_TO_WELCOME_PAGE = 'FRELANCER_CARD_INCOGNITO_GO_TO_WELCOME_PAGE';
export type FRELANCER_CARD_INCOGNITO_GO_TO_WELCOME_PAGE = typeof FRELANCER_CARD_INCOGNITO_GO_TO_WELCOME_PAGE;

export interface FetchFreelancerCardAction {
    type: FETCH_FREELANCER_CARD_DATA;
    freelancerLogin: string;
    login: string;
}

export interface FetchFreelancerCardRegisteredDataAction {
    type: FETCH_FREELANCER_CARD_REGISTERED_DATA;
    freelancerLogin: string;
    login: string;
    freelancerCardReady: boolean;
}

export interface UpdateFreelancerCardAction {
    type: UPDATE_FREELANCER_CARD_DATA;
    freelancer?: Freelancer;
    operator?: FreelancerCardOperator;
}

export interface ShowFreelancerContactsAction {
    type: SHOW_FREELANCER_CONTACTS;
}

export interface UpdateFreelancerStatusAction {
    type: UPDATE_FREELANCER_STATUS;
    status: string;
}

export interface UpdateFreelancerStatusErrorAction {
    type: HANDLE_UPDATE_FREELANCER_STATUS_ERROR;
}

export interface UpdateFreelancerStatusSuccessAction {
    type: HANDLE_UPDATE_FREELANCER_STATUS_SUCCESS;
    status: string;
}

export interface OpenAcceptFreelancerCoopRequestByClientAction {
    type: OPEN_ACCEPT_FREELANCER_COOP_REQUEST_BY_CLIENT;
}

export interface CloseAcceptFreelancerCoopRequestByClientAction {
    type: CLOSE_ACCEPT_FREELANCER_COOP_REQUEST_BY_CLIENT;
}

export interface AcknowledgeUserStayedOnCardAction {
    type: ACKNOWLEDGE_USER_STAYED_ON_CARD;
}

export interface ReleaseFreelancerCardAction {
    type: RELEASE_FREELANCER_CARD;
}

export type UpdateFreelancerCardPrivateDataActionParams = Pick<
    Freelancer,
    'cardModerationStatus' | 'contacts' | 'avatarLink' | 'about' | 'quality'
>;

export interface UpdateFreelancerCardPrivateDataAction {
    type: UPDATE_FREELANCER_CARD_PRIVATE_DATA;
    payload: UpdateFreelancerCardPrivateDataActionParams;
}

export interface UpdateFreelancerCustomerDataActionParams {
    customer: FreelancerCustomer;
    feedbacks: FreelancerFeedbackItem[];
    hasPublicCard: boolean;
}

export interface UpdateFreelancerCustomerDataAction {
    type: UPDATE_FREELANCER_CUSTOMER_DATA;
    payload: UpdateFreelancerCustomerDataActionParams;
}

export interface SetFreelancerCardErrorAction {
    type: SET_FREELANCER_CARD_ERROR;
    error?: Error;
}

export interface SetFreelancerCardNotFoundAction {
    type: SET_FREELANCER_CARD_NOT_FOUND;
}

export interface FreelancerCardUpdateCustomerPhoneAction {
    type: FREELANCER_CARD_UPDATE_CUSTOMER_PHONE;
    value: string;
}

export interface FreelancerCardIncognitoGoToPassportAction {
    type: FRELANCER_CARD_INCOGNITO_GO_TO_PASSPORT;
}

export interface FreelancerCardIncognitoGoToWelcomePageAction {
    type: FRELANCER_CARD_INCOGNITO_GO_TO_WELCOME_PAGE;
}

export function fetchFreelancerCard(freelancerLogin: string, login: string): FetchFreelancerCardAction {
    return {
        type: FETCH_FREELANCER_CARD_DATA,
        freelancerLogin,
        login
    };
}

export function fetchFreelancerCardRegisteredData(
    freelancerLogin: string,
    login: string,
    freelancerCardReady: boolean
): FetchFreelancerCardRegisteredDataAction {
    return {
        type: FETCH_FREELANCER_CARD_REGISTERED_DATA,
        freelancerLogin,
        login,
        freelancerCardReady
    };
}

export function updateFreelancerCard(
    freelancer?: Freelancer,
    operator?: FreelancerCardOperator
): UpdateFreelancerCardAction {
    return {
        type: UPDATE_FREELANCER_CARD_DATA,
        freelancer,
        operator
    };
}

export function showFreelancerContacts(): ShowFreelancerContactsAction {
    return {
        type: SHOW_FREELANCER_CONTACTS
    };
}

export function updateFreelancerStatus(status: GdFreelancerStatus): UpdateFreelancerStatusAction {
    return {
        type: UPDATE_FREELANCER_STATUS,
        status
    };
}

export function handleUpdateFreelancerStatusSuccess(status: GdFreelancerStatus): UpdateFreelancerStatusSuccessAction {
    return {
        type: HANDLE_UPDATE_FREELANCER_STATUS_SUCCESS,
        status
    };
}

export function handleUpdateFreelancerStatusError(): UpdateFreelancerStatusErrorAction {
    return {
        type: HANDLE_UPDATE_FREELANCER_STATUS_ERROR
    };
}

export function openAcceptFreelancerCoopRequestByClient(): OpenAcceptFreelancerCoopRequestByClientAction {
    return {
        type: OPEN_ACCEPT_FREELANCER_COOP_REQUEST_BY_CLIENT
    };
}

export function closeAcceptFreelancerCoopRequestByClient(): CloseAcceptFreelancerCoopRequestByClientAction {
    return {
        type: CLOSE_ACCEPT_FREELANCER_COOP_REQUEST_BY_CLIENT
    };
}

export interface WithdrawRequestByClientStartAction {
    type: WITHDRAW_REQUEST_BY_CLIENT_START;
    freelancerId: string;
    projectId: string;
}

export interface WithdrawRequestByClientSuccessAction {
    type: WITHDRAW_REQUEST_BY_CLIENT_SUCCESS;
}

export interface WithdrawRequestByClientErrorAction {
    type: WITHDRAW_REQUEST_BY_CLIENT_ERROR;
}

export function withdrawRequestByClientStart(
    freelancerId: string,
    projectId: string
): WithdrawRequestByClientStartAction {
    return {
        type: WITHDRAW_REQUEST_BY_CLIENT_START,
        freelancerId,
        projectId
    };
}

export function withdrawRequestByClientSuccess(): WithdrawRequestByClientSuccessAction {
    return {
        type: WITHDRAW_REQUEST_BY_CLIENT_SUCCESS
    };
}

export function withdrawRequestByClientError(): WithdrawRequestByClientErrorAction {
    return {
        type: WITHDRAW_REQUEST_BY_CLIENT_ERROR
    };
}

export function acknowledgeUserStayedOnCard(): AcknowledgeUserStayedOnCardAction {
    return {
        type: ACKNOWLEDGE_USER_STAYED_ON_CARD
    };
}

export function releaseFreelancerCard(): ReleaseFreelancerCardAction {
    return {
        type: RELEASE_FREELANCER_CARD
    };
}

export function updateFreelancerCardPrivateData(
    payload: UpdateFreelancerCardPrivateDataActionParams
): UpdateFreelancerCardPrivateDataAction {
    return {
        type: UPDATE_FREELANCER_CARD_PRIVATE_DATA,
        payload
    };
}

export function updateFreelancerCustomerData(
    payload: UpdateFreelancerCustomerDataActionParams
): UpdateFreelancerCustomerDataAction {
    return {
        type: UPDATE_FREELANCER_CUSTOMER_DATA,
        payload
    };
}

export function setFreelancerCardError(error?: Error): SetFreelancerCardErrorAction {
    return {
        type: SET_FREELANCER_CARD_ERROR,
        error
    };
}

export function setFreelancerCardNotFound(): SetFreelancerCardNotFoundAction {
    return {
        type: SET_FREELANCER_CARD_NOT_FOUND
    };
}

export function freelancerCardUpdateCustomerPhone(value: string): FreelancerCardUpdateCustomerPhoneAction {
    return {
        type: FREELANCER_CARD_UPDATE_CUSTOMER_PHONE,
        value
    };
}

export function freelancerCardIncognitoGoToPassport(): FreelancerCardIncognitoGoToPassportAction {
    return {
        type: FRELANCER_CARD_INCOGNITO_GO_TO_PASSPORT
    };
}

export function freelancerCardIncognitoGoToWelcomePage(): FreelancerCardIncognitoGoToWelcomePageAction {
    return {
        type: FRELANCER_CARD_INCOGNITO_GO_TO_WELCOME_PAGE
    };
}

export type FreelancerCardAction =
    | FetchFreelancerCardAction
    | FetchFreelancerCardRegisteredDataAction
    | UpdateFreelancerCardAction
    | ShowFreelancerContactsAction
    | UpdateFreelancerStatusAction
    | UpdateFreelancerStatusErrorAction
    | UpdateFreelancerStatusSuccessAction
    | OpenAcceptFreelancerCoopRequestByClientAction
    | CloseAcceptFreelancerCoopRequestByClientAction
    | WithdrawRequestByClientStartAction
    | WithdrawRequestByClientSuccessAction
    | WithdrawRequestByClientErrorAction
    | AcknowledgeUserStayedOnCardAction
    | ReleaseFreelancerCardAction
    | UpdateFreelancerCardPrivateDataAction
    | UpdateFreelancerCustomerDataAction
    | SetFreelancerCardErrorAction
    | SetFreelancerCardNotFoundAction
    | FreelancerCardUpdateCustomerPhoneAction
    | FreelancerCardIncognitoGoToPassportAction
    | FreelancerCardIncognitoGoToWelcomePageAction;
